<template>
<div class="chapter">
<div class="inner_page">
<div class="pgmonospaced">
<br class="calibre1"/>
<br class="calibre1"/>
</div>
<div class="illo" id="cover"></div>
<div class="illo" id="illo1">
<a class="pcalibre pcalibre2 pcalibre1" id="page102" title="102"></a> <img alt="A man dangles the head of a 'boy' which has wires coming out of its neck." class="calibre2" src="OEBPS/Images/%40public%40vhost%40g%40gutenberg%40html%40files%4032032%4032032-h%40images%40illo1-sm.jpg"/> <a class="pcalibre pcalibre3 pcalibre2 pcalibre1">Left side image</a> <a class="pcalibre pcalibre3 pcalibre2 pcalibre1">Right side image</a>
</div>
<h1 class="calibre3" id="pgepubid00000"><a class="pcalibre pcalibre4 pcalibre2 pcalibre1" id="page103" title="103"></a>SECOND VARIETY</h1>
<p class="calibre4" id="author">BY PHILIP K. DICK</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1065f14e